import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';

import { ANALYTICS_SOURCE, OPEN_GRAPH_ACTION_SUBJECT_ID } from '../analytics.ts';
import { useTwgAnalyticsEvents } from '../useTwgAnalyticsEvents.ts';

const i18n = defineMessages({
	label: {
		id: 'byline-connections.preview-panel.open-graph-button.view-teamwork-graph',
		defaultMessage: 'View Teamwork Graph',
		description:
			'Label of the button in the Teamwork Graph preview panel header that opens the full-size Teamwork Graph modal. "Teamwork Graph" is a product name.',
	},
});

export type TeamworkGraphPreviewPanelOpenGraphButtonProps = {
	onClick: () => void;
};

/**
 * The preview panel header's entry to the full-size graph. The in-panel canvas preview used to
 * be that affordance; the header button is now the only opener.
 */
export const TeamworkGraphPreviewPanelOpenGraphButton = ({
	onClick,
}: TeamworkGraphPreviewPanelOpenGraphButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useTwgAnalyticsEvents();

	const handleClick = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: OPEN_GRAPH_ACTION_SUBJECT_ID,
				source: ANALYTICS_SOURCE,
			},
		}).fire();
		onClick();
	}, [createAnalyticsEvent, onClick]);

	return (
		<Button
			appearance="default"
			onClick={handleClick}
			testId="teamwork-graph-preview-panel.open-graph-button"
		>
			{formatMessage(i18n.label)}
		</Button>
	);
};
